import { render, staticRenderFns } from "./OneForm.vue?vue&type=template&id=7097e67c&"
import script from "./OneForm.vue?vue&type=script&lang=js&"
export * from "./OneForm.vue?vue&type=script&lang=js&"
import style0 from "./OneForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports